import { useMemo, useState } from 'react'
import BreakdownShell, { SortHeader, useSortedUnits } from './BreakdownShell.jsx'

// ReorderBreakdownTable — by-unit items below par + critical count
// (zero on hand, lead time <= 2 days). Footer totals equal the
// Items Below Par headline KPI by construction.

export default function ReorderBreakdownTable({ perUnit, onBack }) {
  // --- All hooks BEFORE any conditional return (React #310). ---
  const [sortKey, setSortKey] = useState('items_below_par_count')
  const [sortDir, setSortDir] = useState('desc')
  const rows = useSortedUnits(perUnit, sortKey, sortDir)

  const { totalBelow, totalCritical } = useMemo(() => {
    let below = 0, critical = 0
    for (const r of rows) {
      below += Number(r.items_below_par_count) || 0
      critical += Number(r.items_critical_count) || 0
    }
    return { totalBelow: below, totalCritical: critical }
  }, [rows])

  function toggle(key) {
    if (key === sortKey) setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'))
    else { setSortKey(key); setSortDir('desc') }
  }

  return (
    <BreakdownShell title="Items below par by location" onBack={onBack}>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-black/10 text-left text-[11px] uppercase tracking-wide text-black/55">
            <SortHeader label="Location" k="name" sortKey={sortKey} sortDir={sortDir} onClick={toggle} />
            <SortHeader label="Below par" k="items_below_par_count" sortKey={sortKey} sortDir={sortDir} onClick={toggle} align="right" />
            <SortHeader label="Critical" k="items_critical_count" sortKey={sortKey} sortDir={sortDir} onClick={toggle} align="right" />
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const crit = Number(r.items_critical_count) || 0
            return (
              <tr key={r.id} className="border-b border-black/5 last:border-b-0">
                <td className="py-2.5 pr-3 font-medium text-black/85">{r.name}</td>
                <td className="py-2.5 pl-3 text-right tabular-nums text-black/85">{Number(r.items_below_par_count) || 0}</td>
                <td className={`py-2.5 pl-3 text-right tabular-nums ${crit > 0 ? 'text-red-700 font-medium' : 'text-black/85'}`}>{crit}</td>
              </tr>
            )
          })}
        </tbody>
        <tfoot>
          <tr className="border-t-2 border-black/15 font-semibold">
            <td className="py-2.5 pr-3 text-black/85">All units</td>
            <td className="py-2.5 pl-3 text-right tabular-nums text-black/85">{totalBelow}</td>
            <td className={`py-2.5 pl-3 text-right tabular-nums ${totalCritical > 0 ? 'text-red-700' : 'text-black/85'}`}>{totalCritical}</td>
          </tr>
        </tfoot>
      </table>
    </BreakdownShell>
  )
}
